import React from 'react';
import { cn } from '@/lib/utils';
import Routes from '../../routes';

export default function MainContainer({ isAuthRoute }) {
  return (
    <div className="flex min-h-0 w-full min-w-0 flex-1 flex-col md:flex-row">
      <div
        className={cn(
          'flex min-w-0 flex-1 flex-col',
          isAuthRoute
            ? 'min-h-0 overflow-visible'
            : 'bethere-main-scroll min-h-[calc(100vh-4rem)] overflow-y-auto',
        )}
      >
        <div className="box-border mx-auto w-full max-w-[1440px] flex-1 px-4 py-6 md:px-6 md:py-8">
          <Routes />
        </div>
      </div>
    </div>
  );
}
